var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"lg":8}},[_vm._v("\n    "+_vm._s(_vm.title)),_c('br'),_c('small',[_vm._v(_vm._s(_vm.subtitle))])]),(_vm.customer)?_c('el-col',{attrs:{"offset":8,"lg":8}},[_c('CustomerList',{on:{"selected":_vm.selected}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }